import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IStudycontant } from "../../../Pages/StudyNote.tsx/IStudyNote";

export const ListSubjectNoteContentSlice = createSlice({
  name: "ListSubjectNoteContentSlice",
  initialState: {} as IReduxState<IStudycontant[]>,

  reducers: {
    listListSubjectNoteContentSlice: (
      state,
      _: PayloadAction<IStudycontant>
    ) => {
      state.isLoading = true;
    },
    successListSubjectNoteContentSlice: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListSubjectNoteContentSlice: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  listListSubjectNoteContentSlice,
  successListSubjectNoteContentSlice,
  failureListSubjectNoteContentSlice,
} = ListSubjectNoteContentSlice.actions;

export default ListSubjectNoteContentSlice.reducer;
